import React from "react";
import { Stack, Box, Heading } from "@origin-digital/ods-core";
import ReadOnlyTextField from "../FormComponents/ReadOnlyTextField";
import { getFullName } from "../ChangeRequest/helpers";

interface ReadOnlyBusinessPrimaryForPageTwoProps {
  firstName: string;
  lastName: string;
  dateOfBirth: Date | null;
  phone: string;
  email: string;
  formatDate: (date: Date | null) => string;
}

const ReadOnlyBusinessPrimaryForPageTwo: React.FC<
  ReadOnlyBusinessPrimaryForPageTwoProps
> = ({ firstName, lastName, dateOfBirth, phone, email, formatDate }) => (
  <Stack space={["large", "xlarge"]}>
    <Heading variant="h4">Primary contact</Heading>
    <Stack>
      {/* Name */}
      <ReadOnlyTextField
        label="Name"
        value={getFullName(firstName, lastName)}
      />
      {/* End Name */}
      {/* DOB + Phone */}
      <Box
        display="flex"
        flexDirection={{
          xs: "column",
          sm: "row",
        }}
      >
        {/* Date of birth */}
        <ReadOnlyTextField
          label="Date of birth"
          value={formatDate(dateOfBirth)}
        />
        {/* End Date of birth */}
        {/* Phone */}
        <ReadOnlyTextField label="Phone" value={phone} />
        {/* End Phone */}
      </Box>
      {/* End DOB + Phone */}
      {/* Email */}
      <ReadOnlyTextField label="Email" value={email} />
      {/* End Email */}
    </Stack>
  </Stack>
);

export default ReadOnlyBusinessPrimaryForPageTwo;
